import Input from "../../../../../components/Common/Input";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import FormContainer from "../../../../Components/MyAccount/FormContainer";
import LoadingButton from "../../../../../components/LoadingButton";
import { callAPI, isValidEmailAddress } from "../../../../../lib/common";
import Link from "@mui/material/Link";

const UserName = styled.h5`
  font-size: 24px;
  text-transform: none;
  display: block;
  margin-bottom: 0.5em;
  margin-top: 0.5em;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export default ({ userInfo }) => {
  const { t } = useTranslation();
  const [editMode, setEditMode] = useState();

  console.log("User info", userInfo);

  return (
    <FormContainer>
      <h4>{t("User")}</h4>
      {!editMode && (
        <ShowUserName
          userName={userInfo.username}
          onEditUserName={() => setEditMode(true)}
        />
      )}
      {editMode && <EditUserName userName={userInfo.username} />}
    </FormContainer>
  );
};

const ShowUserName = ({ userName, onEditUserName }) => {
  const { t } = useTranslation();
  return (
    <>
      <UserName>{userName}</UserName>
      <Link href="#" onClick={() => onEditUserName()}>
        {t("Change user name")}
      </Link>
    </>
  );
};

export const EditUserName = (props) => {
  const { t } = useTranslation();
  const [userName, setUserName] = useState(props.userName);
  const [error, setError] = useState();
  const inputRef = useRef();
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    console.log("We got a inputref!", inputRef);
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleEmailChange = (e) => {
    let error = null;
    setUserName(e.target.value);
    if (!isValidEmailAddress(e.target.value)) {
      error = t("The email address provided is not a valid email address.");
    }
    setError(error);
  };

  const updateUserName = () => {
    setUpdating(true);
    callAPI("/ajax/user/update_username.php", "POST", { username: userName })
      .then((data) => {
        if (data.error) {
          setError(data.error);
        } else {
          // All good, just reload the page:
          location.reload();
        }
      })
      .finally(() => {
        setUpdating(false);
      });
  };

  return (
    <>
      <Input
        type="email"
        error={error}
        onChange={handleEmailChange}
        value={userName}
        label={t("User name")}
        innerRef={(ref) => (inputRef.current = ref.current)}
      />
      <LoadingButton
        color="primary"
        fullWidth
        isLoading={updating}
        disabled={!!error || props.userName === userName}
        onClick={() => updateUserName()}
      >
        {t("Change user name")}
      </LoadingButton>
    </>
  );
};
